import { Pipe, PipeTransform } from '@angular/core';

// Interfaces
import { UsuarioxRol } from '@usuarios/pages/usuarios-page/interfaces/';

@Pipe({ name: 'RazonSocial' })
export class RazonSocialPipe implements PipeTransform {
  transform(id: number | null, usuarios: UsuarioxRol[]): string {
    if (!id || !usuarios) return '';
    const usuario = usuarios.find((m) => m.personaId === id);
    return usuario?.razonSocial || id.toString();
  }
}
